import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';

export function ExpiredBadge(): ReactElement | null {
  const status = useFlexiForwardSelector((flexiForward) => flexiForward.properties.rfs?.status ?? 'NOT_PRICEABLE');

  return status === 'EXPIRED' ? (
    <div className="d-flex justify-content-center position-absolute w-100 mt-4px">
      <span
        className="badge rounded-pill badge-secondary fs-12 position-relative"
        style={{ paddingTop: '2px', paddingBottom: '2px', bottom: '2px' }}
        data-e2e="expired-price"
      >
        <FormattedMessage id="streaming.expired.price" />
      </span>
    </div>
  ) : null;
}
